<template>
  <div class="w-full">
    <cardTitle title="今日班会执行情况" cardType='shimen'/>
    <v-chart
      :options="classMeetingOptions"
      class="!h-[calc(100%-62px)] !w-full"
      :autoresize="true"
    ></v-chart>
  </div>
</template>

<script>
import CardTitle from '@/components/cockpit/CardTitle'
import CockpitService from '../../service/index'

export default {
  name: '',
  props: [],
  components: { CardTitle },

  data() {
    return {
      initInterval: null,
      classMeetingOptions: {
        grid: {
          top: '15%',
          left: '2%',
          right: '2%',
          bottom: '0%',
          containLabel: true,
        },
        legend: {
          left: 'center',
          top: '5',
          show: true,
          textStyle: {
            color: '#fff',
            padding: [2, 0, 0, 0],
          },
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(40, 48, 48, 0.3)',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
          },
          padding: 10,
          textStyle: {
            color: '#fff',
            align: 'left'
          },
        },
        xAxis: {
          type: 'category',
          splitLine: { show: false },
          axisLabel: {
            show: true,
            interval: (i, v) => {
              return true
            }, // 避免最后一项文字加深
            margin: 15,
            color: '#fff90',
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.6)',
            },
          },
          axisTick: {
            show: false,
            lineStyle: {
              color: 'rgba(0, 0, 0, .5)',
            },
          },
          data: [],
        },
        yAxis: {
          name: '',
          nameLocation: 'start',
          nameGap: 10,
          nameTextStyle: {
            color: '#fff9',
            padding: [0, 0, 0, -30],
          },
          type: 'value',
          axisLine: {
            show: false,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.6)',
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            fontSize: 12,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#D9D9D919',
            },
          },
        },
        series: [
          {
            name: '已完成',
            type: 'bar',
            stack: '数量',
            barWidth: 20,
            itemStyle: {
              normal: {
                // 这里是颜色
                color: '#67C23A',
              },
            },
            data: [],
          },
          {
            name: '未完成',
            type: 'bar',
            stack: '数量',
            barWidth: 20,
            itemStyle: {
              normal: {
                // 这里是颜色
                color: '#ffff00',
              },
            },
            data: [],
          },
        ],
      },
    }
  },
  methods: {
    async getPreClassMeetingStatistics() {
      const [err, res] = await CockpitService.getPreClassMeetingStatistics()
      if (res && res.code === 0 && res.data) {
        this.classMeetingOptions.xAxis.data = _.map(res.data, 'name')
        this.classMeetingOptions.series[0].data = _.map(res.data, 'finished')
        this.classMeetingOptions.series[1].data = _.map(res.data, 'unfinished')
      }
      console.log(res)
    },
  },
  beforeDestroy() {
    clearInterval(this.initInterval)
  },
  mounted() {
    this.getPreClassMeetingStatistics()
    this.initInterval = setInterval(() => {
      this.getPreClassMeetingStatistics()
    }, 5000)
  },
}
</script>

<style lang="scss" scoped>
</style>
